module.exports = __webpack_public_path__ + "static/media/slaveBlue1.33798333.svg";